import { AxiosPromise } from 'axios'

import api from '@config/api'

export function postOtbFollowUp(data: any, page: number): AxiosPromise {
  return api.post('v1/OTB/Acompanhamento', data, {
    params: {
      pagination: JSON.stringify({
        actualPage: page,
        rows: 200
      })
    }
  })
}

export function postOtbFollowUpAll(data: any): AxiosPromise {
  return api.post('v1/OTB/Acompanhamento', data, {
    params: {}
  })
}

export function postExportData(data: any): AxiosPromise {
  return api.post('v1/OTB/Acompanhamento/Exportar', data)
}

export default {
  postOtbFollowUp,
  postOtbFollowUpAll,
  postExportData
}
